var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseTemplateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66661 4.9987H16.3333C16.7916 4.9987 17.1666 4.6237 17.1666 4.16536C17.1666 3.70703 16.7916 3.33203 16.3333 3.33203H4.66661C4.20827 3.33203 3.83327 3.70703 3.83327 4.16536C3.83327 4.6237 4.20827 4.9987 4.66661 4.9987ZM17.2999 6.4987C17.2249 6.11536 16.8833 5.83203 16.4833 5.83203H4.51661C4.11661 5.83203 3.77494 6.11536 3.69994 6.4987L2.86661 10.6654C2.76661 11.182 3.15827 11.6654 3.68327 11.6654H3.83327V15.832C3.83327 16.2904 4.20827 16.6654 4.66661 16.6654H11.3333C11.7916 16.6654 12.1666 16.2904 12.1666 15.832V11.6654H15.4999V15.832C15.4999 16.2904 15.8749 16.6654 16.3333 16.6654C16.7916 16.6654 17.1666 16.2904 17.1666 15.832V11.6654H17.3166C17.8416 11.6654 18.2333 11.182 18.1333 10.6654L17.2999 6.4987ZM10.4999 14.9987H5.49994V11.6654H10.4999V14.9987Z",
    fill: "#185772"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseTemplateIcon);
export default __webpack_public_path__ + "static/media/PurchaseTemplateIcon.5ecfa30ea667a796eac721b1b7283b3c.svg";
export { ForwardRef as ReactComponent };